import { QueryClientProvider } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { createQueryClient } from '@/sdk/context';

export const Route = createFileRoute('/auth/login')({
  component: LoginRouteComponent,
});

function LoginRouteComponent() {
  const [queryClient] = useState(() => createQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <LoginPage />
    </QueryClientProvider>
  );
}
